import styled from 'styled-components'

export const List = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 12px;
`
